import {
    Source
} from 'one-model-local';
import {
    sortFunction
} from './transformCaller';

import { format } from 'one-util-date';

/**
 * This function transforms the patientlookup response into
 * a Source Object of type array.
 * @param response contains the patientlookup response
 * @param context contains settings json file etc ..
 */
export const TransformPatient = (response: any, soucetypelookup:any, context: any) => {
    const { settings } = context;
    const {uisettings:{dateformat}} = settings
    let sourcedata: Source[] = [];
    if (response && response.length > 0) {
        response.map((ele: any) => {
            let source: Source = {
                id: undefined,
                mrn: undefined,
                dob: undefined,
                gender: undefined,
                contact: undefined,
                contact_formatted: undefined,
                address: undefined,
                lastname: undefined,
                firstname: undefined,
                middlename: undefined,
                preferredName: undefined
            };
            source.id = ele?.id;
            source.mrn = ele?.mrn;
            source.initials= ele?.lastname.charAt(0) + ele?.firstname.charAt(0);
            source.firstname = ele?.lastname+" "+ele?.firstname;
            source.lastname = ele?.lastname;
            source.preferredName = ele.preferredName;
            source.dob = ele?.dob ? format(ele.dob,dateformat) : "";
            source.gender = ele?.gender;
            source.address = ele?.address;
            source.contact = ele?.contact;
            source.contact_formatted = ele?.contact_formatted;
            source.typename = soucetypelookup 
                                && soucetypelookup[0]
                                && soucetypelookup[0]?.label;
            source.email = ele?.email;
            source.ssn = ele?.ssn;                  
            sourcedata.push(source);
        });
    }
    // ADPAC-317
    sourcedata.sort(sortFunction);
    return sourcedata;
}